module.exports = __webpack_public_path__ + "static/media/68.cee82dd4.png";